import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoadingAddOns, data } = state.master;
  return {
    isLoadingAddOns,
    data,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
